<main aria-labelledby="ctnInfoMainContainer" [ngClass]="{'ctn-info-page': !(pageData && deviceInfo && showLIC)}">
  <div class="ctn-info" *ngIf="pageData">
  <div *ngIf='initModal'>
    <app-modal *ngIf="showSupport" [showModal]="showSupport" [modalClass]="modalClass">
      <app-confirm-modal  [modalPopupObject]='confirmModalPopup' [triggerElement]='eventEmit' (modalOutput)="closeModal($event)">
      </app-confirm-modal>
    </app-modal>
    <app-modal *ngIf="showSMS" [showModal]="showSMS" [modalClass]="modalClass">
     <app-message-modal [ctnDetails]="ctnDetails" [triggerElement]='eventEmit' (modalOutput)="closeModal($event)"></app-message-modal>
    </app-modal>
  </div>
  <div *ngIf='initDeviceLockModal'>
    <app-modal [showModal]="initDeviceLockModal" [modalClass]="modalClass">
      <app-device-lock [ctn]="ctnDetails.ctn" [fan]="ctnDetails.fan" [ban]="ctnDetails.ban" [triggerElement]='eventEmit' (modalOutput)="closeDeviceLockModal($event)"
        (responseVal)="showSuccessMessageLock($event)">
      </app-device-lock>
    </app-modal>
  </div>
  <div *ngIf='initDeviceWipeModal'>
    <app-modal [showModal]="initDeviceWipeModal" [modalClass]="modalClass">
      <app-device-wipe [ctn]="ctnDetails.ctn" [fan]="ctnDetails.fan" [ban]="ctnDetails.ban" [triggerElement]='eventEmit' (modalOutput)="closeDeviceWipeModal($event)"
        (responseVal)="showSuccessMessageWipe($event)">
      </app-device-wipe>
    </app-modal>
  </div>
  <!-- claim modal -->
  <div *ngIf="initClaimUnclaim">
    <app-modal [showModal]="initClaimUnclaim" [triggerElement]='eventEmit' [modalClass]="modalClass" (modalOutput)="closeModalClaimUnclaim($event)">
       <div class="message-modal">
        <div class="modal-header">
            <h2 id='modalHeading' tabindex="0">{{claimUnclaimInfo.title}}</h2>
        </div>
        <div class="corner-button">
            <button class="close" aria-label="Close" (click)="closeModalClaimUnclaim(false)" tabindex="0">x</button>
        </div>
        <div class="modal-body">
            <p *ngIf="claimUnclaimInfo.name === 'claim'">Please confirm {{claimUnclaimInfo.name}}ing of the selected device from {{productIdName}} {{productId}}.</p>
            <p *ngIf="claimUnclaimInfo.name === 'unclaim'">Please confirm {{claimUnclaimInfo.name}}ing of the selected device from {{productIdName}} {{productId}}.
            This will remove the device from {{productName}}.</p>
            <p><strong>Selected</strong>
               IMEI: {{ctnDetails.deviceInfo.imei}}</p>
            <p>{{claimUnclaimInfo.name | titlecase}}ing of the device might take up to 24 hours. While we process your request {{claimUnclaimInfo.name}} functionality will be disabled.
              If your device is not {{claimUnclaimInfo.name}}ed after 24 hours, please contact customer support.</p>
        </div>
        <div class="text-right modal-footer row">
          <button class="btn btn-secondary col-md-5 col-sm-12 pull-right" tabindex="0" (click)="ok(claimUnclaimInfo.name)" (keydown.enter)="ok(claimUnclaimInfo.name)" id="device-lock-btn" checkImpersonator>Confirm</button>
          <a class="btn btn-link btn-block col-md-6 col-sm-12 btn-cancel pull-right text-right cancel-button-modal" tabindex="0" (click)="closeModalClaimUnclaim($event)">Cancel</a>
        
        </div>
      </div>
    </app-modal>
  </div>
  <!-- unclaim modal -->
  <section aria-labelledby="ctnInfoMainContainer">
      <h1 id="ctnInfoMainContainer" class="pageHeading">Wireless number: {{ctn}}</h1>
    <div class="alert valign-children-middle" *ngIf="error|| showErrorLock || showErrorWipe || showErrorClaimUnclaim">
      <div class="alert-error">
        <i class="icon-badgealert" role="img" aria-label="Error" tabindex="0"></i>
      </div>
      <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="Close" tabindex="0"></div>
      <div *ngIf="showErrorClaimUnclaim"><span>Something went wrong. We were unable to {{claimUnclaimInfo.name}} the device. Please Try again</span></div>
	    <!-- <div>
        <span>Display text for error states in this area.</span>
    </div> -->
    </div>
    <div class="alert valign-children-middle" *ngIf="smsSent||showSuccessLock||showSuccessWipe||showSuccessClaimUnclaim">
      <div class="alert-success">
        <i class="icon-approval" role="img" aria-label="Success" tabindex="0"></i>
      </div>
     <!-- <div>Your message has been sent.</div> -->
      <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="Close" tabindex="0"></div>
		  <div *ngIf="smsSent"><span>Your message has been sent.</span></div>
      <div *ngIf="showSuccessLock"><span>We've received your request to lock this device.</span></div>
      <div *ngIf="showSuccessWipe"><span>We're processing your request to wipe this device. This might take a while.</span></div>
      <div *ngIf="showSuccessClaimUnclaim"><span>We've received the request to {{claimUnclaimInfo.name}} the device and are processing it now.</span></div>
      <!-- <div class="pull-right close" (click)="dismissInfo()"></div> -->
    </div>
    <div>
      <p>{{pageData.fanLabel}} <span><a href="javascript:void(0)"  [attr.aria-label]="pageData.fanLabel + ctnDetails.fan " (click)="onFanClick()">{{ctnDetails.fan}}</a></span></p>
      <p>{{pageData.banLabel}} <span>{{ctnDetails.ban}}</span></p>
    </div>
    <div class="userInfoContainer">
      <p class="groupName">{{pageData.groupNameLabel}} <span>{{ctnDetails.groupName}}</span></p>
      <p>{{pageData.userNameLabel}} <span>{{ctnDetails.userName}}</span></p>
      <p>{{pageData.rateLabel}} <span>{{ctnDetails.ratePlan}}</span></p>
      <p>{{pageData.idLabel}} <span>{{ctnDetails.userId}}</span></p>
      <p>{{pageData.mailLabel}} <span>{{ctnDetails.emailId}}</span></p>
    </div>
    <div class="nav-container" *ngIf='oemStatus === false'>
      <ul class="ctn-nav-icons">
        <li *ngFor="let nav of pageData.navLinks">
         <button title="Opens a dialog." class="link-button" type="button" (click)="navigate(nav.route)" [disabled]="nav.disable">
              <figure>
                 <img  [src]="nav.imgUrl" [alt]="nav.label"/>
              </figure>
              <a [innerHtml]="nav.label"></a>
          </button>
			    <!--added if condition for device lock and wipe user story -->
          <!-- <button *ngIf = "!check(nav.route)" class="link-button" type="button" (click)="navigate(nav.route)" [checkRole]="nav.fieldPermission">
              <figure>
                 <img [src]="nav.imgUrl" [alt]="nav.label" *hasPermission = "nav.fieldPermission"/>
                 <img  [src]="nav.disabledImgUrl" [alt]="nav.label" *hasPermission = "'!'+nav.fieldPermission" />
              </figure>
              <a *ngIf = "!check(nav.route)" class='disabled' [innerHtml]="nav.label"></a>

          </button>-->
          <!--added the disabled image for device lock and wipe user story -->
          <!-- <button *ngIf = "check(nav.route)" [disabled] = "check(nav.route)" class="link-button" type="button" >
              <figure>
                 <img  [src]="nav.disabledImgUrl" [alt]="nav.label"/>
              </figure>
              <a class = 'disabled' [innerHtml]="nav.label"></a>
          </button>	  -->
        </li>
      </ul>
    </div>
    <div class="nav-container" *ngIf='oemStatus === true'>
      <ul class="ctn-nav-icons-oem">
        <li *ngFor="let nav of pageData.navOEMLinks">
         <!-- <button class="link-button" type="button" (click)="navigate(nav.route)" [disabled]="nav.disable">
              <figure>
                 <img  [src]="nav.imgUrl" [alt]="nav.label"/>
              </figure>
              <a [innerHtml]="nav.label"></a>
          </button> -->
			    <!--added if condition for device lock and wipe user story -->
          <button title="Opens a new dialog." *ngIf = "!check(nav.route)" class="link-button" type="button" (click)="navigate(nav.route)" [checkRole]="nav.fieldPermission">
              <figure>
                 <img [src]="nav.imgUrl" [alt]="nav.label" *hasPermission = "nav.fieldPermission"/>
                 <img  [src]="nav.disabledImgUrl" [alt]="nav.label" *hasPermission = "'!'+nav.fieldPermission" />
              </figure>
              <a [innerHtml]="nav.label"></a>
          </button>
          <!--added the disabled image for device lock and wipe user story -->
          <button title="Opens a new dialog. Disabled." *ngIf = "check(nav.route)" [disabled] = "check(nav.route)" class="link-button" type="button" >
              <figure>
                 <img class="img-disabled" [src]="nav.disabledImgUrl" [alt]="nav.label"/>
              </figure>
              <a class="disabled" [innerHtml]="nav.label"></a>
          </button>
        </li>
      

       <!-- Enroll/Un-enroll container -->

        <!-- if device is eligible -->
        <ng-container>


          <!-- Enroll part -->

          <li *ngIf = "displayEnrollIcon">
            <button [disabled]="claimFuncEnable" title="Claim device" class="link-button" type="button" (click)="claimDevice('claim')">

              <figure *ngIf = "!claimFuncEnable"> 
                <img  src="/assets/img/claim-device-active.png" alt="enroll" />
              </figure>

             <figure *ngIf ="claimFuncEnable"> 
              <img  src="/assets/img/claim-device-inactive.png" alt="enroll" />
             </figure>

              <a *ngIf = "!claimFuncEnable" innerHtml="Claim device"> Claim device </a>
              <a *ngIf = "claimFuncEnable" innerHtml="Claim device" disabled> Claim device </a>

            </button>
          </li>



         <!-- Un-enroll part -->

          <li *ngIf = "displayUnenrollIcon">
            <button  [disabled]="unclaimFuncEnable" title="Unclaim device" class="link-button" type="button" (click)="unClaimDevice('unclaim')">

              <figure *ngIf = "!unclaimFuncEnable">
                <img  src="/assets/img/unclaim-device-active.png" alt="enroll" />
              </figure>

             <figure *ngIf = "unclaimFuncEnable">
              <img  src="/assets/img/unclaim-device-inactive.png" alt="enroll" />
             </figure>

             <a *ngIf = "!unclaimFuncEnable" innerHtml="Unclaim device"> Unclaim device </a>

             <a *ngIf = "unclaimFuncEnable" innerHtml="Unclaim device" disabled> Unclaim device </a>
            </button>
          </li>

        </ng-container>
        
      </ul>
    </div>
  </section>
  <section aria-labelledby="devInfoContainer">
    <div class="deviceInfoContainer" *ngIf="deviceInfo">
      <h2 id="devInfoContainer">{{pageData.headerLabel}}</h2>
      <div>
        <p><span> {{deviceInfo.deviceName}} </span></p>
      </div>
      <p>{{pageData.platformLabel}} <span>{{deviceInfo.platform}}</span></p>
      <p>{{pageData.osLabel}} <span>{{deviceInfo.os}}</span></p>
      <p>{{pageData.imeiLabel}} <span>{{imeiList}}</span></p>
      <p *ngIf="!oemStatus">{{pageData.updateLabel}} <span>{{deviceInfo.checkInDate}}</span></p>
    </div>
    <div class="grid-table">
      <table class="table">
        <thead>
          <tr>
            <th>{{pageData.typeLabel}}</th>
            <th>{{pageData.statusLabel}}</th>
          </tr>
        </thead>
        <tbody *ngIf="ctnStatus">
          <tr *ngIf="!oemStatus">
            <td>{{pageData.enrollLabel}}</td>
            <td>
              <app-legend [data]="progressChartData"></app-legend>
            </td>
          </tr>
          <tr class="odd" *ngIf="!oemStatus">
            <td>{{pageData.complianceLabel}}</td>
            <td>{{ctnStatus.complianceStatus}}</td>
          </tr>
          <tr>
            <td>{{pageData.mobilityLabel}}</td>
            <td>{{ctnStatus.mobilityStatus | titlecase}}</td>
          </tr>
          <tr *ngIf="oemStatus">
            <td>{{pageData.deviceLabel}}</td>
            <td>{{oemEnrollmentStatus}}</td>
          </tr>
          <tr *ngIf="oemStatus">
            <td>{{pageData.serviceTypeLabel}}</td>
            <td>{{serviceType}}</td>
          </tr>
          <tr *ngIf="oemStatus">
            <td>{{pageData.serviceDetailLabel}}</td>
            <td>{{enrollmentStatusReason}}</td>
          </tr>
          <tr class="odd" *ngIf="!oemStatus">
            <td>{{pageData.appLabel}}</td>
            <td><span *ngIf="ctnStatus.applicationStatus">{{pageData.appText}}{{ctnStatus.applicationStatus}}</span></td>
          </tr>
          <tr *ngIf="!oemStatus">
            <td>{{pageData.othersLabel}}</td>
            <td>{{ctnStatus.programStatus}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div class="row  text-right button-section">
      <div class="col-md-12 col-sm-12">
        <button class="btn btn-default" [disabled]="!ctnDetails.profileId" (click)="viewProfile()" [checkRole]="pageData.fieldPermissions.fanDeploymentProfile">{{pageData.buttonText}}</button>
      </div>
    </div> -->
    </section>
    <section aria-label="Help section" class="accordion-section" *ngIf = '!oemStatus && supportArticle'>
      <app-accordion [accordion]="options" [accordionController]=false>
          <app-accordion-list *ngFor="let option of options; let i=index " [option]='option' [isSubAccordion]=true>           
              <div class="support-content" *ngFor="let article of this.article.availableArticle; let i=index">
                <a href="javascript:void(0)" title="Opens a dialog." (click)="getSupportContent(i)" >{{article.name}}</a>
              </div>  
        </app-accordion-list>
      </app-accordion>
    </section>
  
	<!--Report pop up functionality start-->
  <div *ngIf="showReportPopup">
    <app-modal [showModal]="showReportPopup" [modalClass]="modalClass">
      <app-report [modalPopupObject]='confirmModalPopup' [triggerElement]='eventEmit' (modalOutput)="closeReportPopup($event)">
      </app-report>
    </app-modal>
  </div>
  <!-- Report pop up functionality end -->
  </div  >
</main>
<div *ngIf="pageData && deviceInfo && showLIC" class="lic-contest">
    <div class="main-wrapper">
        <h3>{{pageData.LIC.console}}</h3>
        <div class="row">
            <div class="col-sm-12 col-md-6 col-md-size lic-container">
                <div>
                    <label>{{pageData.LIC.fan}}:</label>
                    <abbr>{{ctnDetails.fan}}</abbr>
                </div>
                <div>
                    <label>{{pageData.LIC.provider}}:</label>
                    <abbr>{{deviceInfo.emmProvider}}</abbr>
                </div>
                <div>
                    <label>{{pageData.LIC.tenant}}:</label>
                    <abbr>{{deviceInfo.emmTenantId}}</abbr>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-md-size lic-container">
                <div>
                    <label>{{pageData.LIC.ctn}}:</label>
                    <abbr>{{ctn}}</abbr>
                </div>
                <div>
                    <label>{{pageData.LIC.imei}}:</label>
                    <abbr>{{deviceInfo.imei}}</abbr>
                </div>
                <div>
                    <label>{{pageData.LIC.device}}:</label>
                    <abbr>{{deviceInfo.emmDeviceId}}</abbr>
                </div>
            </div>
        </div>
      </div>
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>
